import { addMessages } from '@hana/i18n';

// Chuỗi Booking. Mã nghiệp vụ (RQ, ROD, BKG), tên riêng, dữ liệu mẫu không dịch.
addMessages('vi', {
  'booking.coord': 'Điều phối',
  'booking.schedule': 'Lịch',
  'booking.sharedMail': 'Điều phối',
  'booking.bulkRod': 'Gửi ROD hàng loạt',
  'booking.newRq': 'Tạo RQ',
  'booking.newReq': 'Tạo yêu cầu',
  'booking.filters': 'Bộ lọc',
  'booking.byVessel': 'Theo tàu',
  'booking.prioNote': '· xử lý trước khi nhận việc mới',
  'booking.mine': 'Tôi xử lý',
  'booking.today': 'Việc hôm nay',
  'booking.retry': 'Thử lại',
  'booking.viewVessel': 'Xem tàu',
  'booking.reschedule': 'Đổi lịch',
  'booking.notifyRest': 'Báo khách còn lại',
  'booking.refresh': 'Làm mới',
  'booking.shortcuts': 'Phím tắt',
  'booking.claim': 'Nhận',
  'booking.claimed': '✓ Đã nhận · đã báo Sale',
  'booking.claimedJob': '✓ Đã nhận · đã báo Sale của job',
  'booking.byStatus': 'Booking theo trạng thái',
  'booking.byCarrier': 'Theo hãng',
  'booking.rqCont': 'số RQ · cont',
  'booking.teamLoad': 'Tải Team BKG',
  'booking.days90': '90 ngày · điểm thao tác',
  'booking.deselect': 'Bỏ chọn',
  'booking.noJob': 'Chưa có job · tạo yêu cầu?',
});
addMessages('en', {
  'booking.coord': 'Coordinator',
  'booking.schedule': 'Schedule',
  'booking.sharedMail': 'Dispatch',
  'booking.bulkRod': 'Send ROD in bulk',
  'booking.newRq': 'New RQ',
  'booking.newReq': 'New request',
  'booking.filters': 'Filters',
  'booking.byVessel': 'By vessel',
  'booking.prioNote': '· handle before taking new work',
  'booking.mine': 'I handle',
  'booking.today': 'Today',
  'booking.retry': 'Retry',
  'booking.viewVessel': 'View vessel',
  'booking.reschedule': 'Reschedule',
  'booking.notifyRest': 'Notify remaining customers',
  'booking.refresh': 'Refresh',
  'booking.shortcuts': 'Shortcuts',
  'booking.claim': 'Claim',
  'booking.claimed': '✓ Claimed · Sales notified',
  'booking.claimedJob': '✓ Claimed · job Sales notified',
  'booking.byStatus': 'Bookings by status',
  'booking.byCarrier': 'By carrier',
  'booking.rqCont': 'RQ count · containers',
  'booking.teamLoad': 'Booking team load',
  'booking.days90': '90 days · action points',
  'booking.deselect': 'Deselect',
  'booking.noJob': 'No job yet · create request?',
});

addMessages('vi', {
  'booking.scheduleTip': 'Lịch điều phối luân phiên T2–T7',
  'booking.coordTip': 'Điều phối mail chung',
  'booking.dispatch': 'Điều phối',
});
addMessages('en', {
  'booking.scheduleTip': 'Rotating coordinator schedule Mon–Sat',
  'booking.coordTip': 'Shared mailbox coordination',
  'booking.dispatch': 'Dispatch',
});

addMessages('vi', {
  'booking.a11y1': 'Yêu cầu booking',
  'booking.a11y2': 'Gửi ROD cho các yêu cầu đang chờ',
  'booking.a11y3': 'Danh sách yêu cầu',
  'booking.a11y4': 'Nhóm yêu cầu',
  'booking.a11y5': 'Nhóm yêu cầu khác',
  'booking.a11y6': 'Tìm BookingNo, JobID, HBL, MBL',
  'booking.a11y7': 'Xoá tìm kiếm',
  'booking.a11y8': 'JobDate · tải lại theo ngày tạo job',
  'booking.a11y9': 'Nhóm theo tàu · ETD gần nhất trước, Chưa có tàu ở cuối',
  'booking.a11y10': 'Báo khẩn P0',
  'booking.a11y11': 'K1 nguy cơ rớt tàu / shut out / roll · K2 thiếu VGM, SI sát cut-off → CS · K3 cont chưa hạ bãi → BKG chủ job · K4 nhiệt độ lệch / LOI → CS · K5 đổi tàu hoặc cut-off khi ETD < 36 giờ → BKG chủ job',
  'booking.a11y12': 'Đã báo · đếm theo đồng hồ',
  'booking.a11y13': 'Việc hôm nay',
  'booking.a11y14': 'Mở hồ sơ tàu',
  'booking.a11y15': 'Nhận xử lý',
  'booking.a11y16': 'Thao tác dòng',
  'booking.a11y17': 'Vol × TypeCont',
  'booking.a11y18': 'Carrier · BookingChannel',
  'booking.a11y19': 'PoL → PoD',
  'booking.a11y20': 'Số booking',
  'booking.a11y21': 'Chủ job (BKG)',
  'booking.a11y22': 'Điều phối mail chung',
  'booking.a11y23': 'Chế độ điều phối',
  'booking.a11y24': 'Nhóm việc booking',
  'booking.a11y25': 'Danh sách RQ',
  'booking.a11y26': 'Tìm RQ, job, booking, khách',
  'booking.a11y27': 'RQ / Job / Booking / Khách',
  'booking.a11y28': 'Hồ sơ tàu',
  'booking.a11y29': 'Nhóm việc',
  'booking.a11y30': 'Bảng bên phải',
  'booking.a11y31': 'Đóng bảng',
  'booking.a11y32': 'Tổng quan booking',
  'booking.a11y33': 'Booking theo hãng',
  'booking.a11y34': 'Hộp thư info@',
  'booking.a11y35': 'Mở hộp thư info@ (phím ])',
  'booking.a11y36': 'Mở hộp thư · phím ]',
  'booking.a11y37': 'Thư chưa Solved · quá SLA theo giờ làm việc',
  'booking.a11y38': 'Bảng SLA trả lời thư',
  'booking.a11y39': 'Nạp lại thư',
  'booking.a11y40': 'Thu hộp thư (phím [)',
  'booking.a11y41': 'Thu hộp thư · phím [',
  'booking.a11y42': 'Tìm thư trên server: tiêu đề, người gửi, JobID, BookingNo',
  'booking.a11y43': 'Tiêu đề, người gửi, JobID, BookingNo',
  'booking.a11y44': 'Lọc theo nhãn',
  'booking.a11y45': 'Phân loại hàng loạt',
  'booking.a11y46': 'Chỉ người điều phối hôm nay được gán',
  'booking.a11y47': 'Đính kèm',
  'booking.a11y48': 'Lọc danh sách yêu cầu theo mã trong tiêu đề',
  'booking.a11y49': 'Tạo yêu cầu từ thư (2 form)',
});
addMessages('en', {
  'booking.a11y1': 'Booking requests',
  'booking.a11y2': 'Send ROD to pending requests',
  'booking.a11y3': 'Request list',
  'booking.a11y4': 'Request groups',
  'booking.a11y5': 'More request groups',
  'booking.a11y6': 'Search BookingNo, JobID, HBL, MBL',
  'booking.a11y7': 'Clear search',
  'booking.a11y8': 'JobDate · reload by job creation date',
  'booking.a11y9': 'Group by vessel · nearest ETD first, no vessel last',
  'booking.a11y10': 'P0 urgent alert',
  'booking.a11y11': 'K1 risk of missing vessel / shut out / roll · K2 missing VGM, SI near cut-off → CS · K3 container not yet gated in → job-owner BKG · K4 temperature deviation / LOI → CS · K5 vessel or cut-off change when ETD < 36 hours → job-owner BKG',
  'booking.a11y12': 'Alerted · counting by clock',
  'booking.a11y13': 'Today\'s tasks',
  'booking.a11y14': 'Open vessel profile',
  'booking.a11y15': 'Take over',
  'booking.a11y16': 'Row actions',
  'booking.a11y17': 'Vol × TypeCont',
  'booking.a11y18': 'Carrier · BookingChannel',
  'booking.a11y19': 'PoL → PoD',
  'booking.a11y20': 'Booking number',
  'booking.a11y21': 'Job owner (BKG)',
  'booking.a11y22': 'Shared mailbox dispatch',
  'booking.a11y23': 'Dispatch mode',
  'booking.a11y24': 'Booking task groups',
  'booking.a11y25': 'RQ list',
  'booking.a11y26': 'Search RQ, job, booking, customer',
  'booking.a11y27': 'RQ / Job / Booking / Customer',
  'booking.a11y28': 'Vessel profile',
  'booking.a11y29': 'Task groups',
  'booking.a11y30': 'Right panel',
  'booking.a11y31': 'Close panel',
  'booking.a11y32': 'Booking overview',
  'booking.a11y33': 'Booking by carrier',
  'booking.a11y34': 'info@ mailbox',
  'booking.a11y35': 'Open info@ mailbox (key ])',
  'booking.a11y36': 'Open mailbox · key ]',
  'booking.a11y37': 'Unsolved mail · past SLA by working hours',
  'booking.a11y38': 'Mail reply SLA board',
  'booking.a11y39': 'Reload mail',
  'booking.a11y40': 'Collapse mailbox (key [)',
  'booking.a11y41': 'Collapse mailbox · key [',
  'booking.a11y42': 'Search mail on server: subject, sender, JobID, BookingNo',
  'booking.a11y43': 'Subject, sender, JobID, BookingNo',
  'booking.a11y44': 'Filter by label',
  'booking.a11y45': 'Bulk classify',
  'booking.a11y46': 'Only today\'s dispatcher can be assigned',
  'booking.a11y47': 'Attachments',
  'booking.a11y48': 'Filter request list by code in subject',
  'booking.a11y49': 'Create request from mail (2 forms)',
});

addMessages('vi', {
  'bkx.newVoyage': 'Tạo chuyến',
  'bkx.resched': 'Đổi lịch',
  'bkx.requests': 'yêu cầu',
  'bkx.noVessel': 'Không có tàu khớp',
  'bkx.vesselProfile': 'Hồ sơ tàu',
  'bkx.cutoffDiff': 'Lệch cut-off · thư hãng khác lịch',
  'bkx.updSchedule': 'Cập nhật lịch · 2 form',
  'bkx.sendNotice': 'Gửi Schedule Notice',
  'bkx.aiInput': 'AI Input từ thư',
  'bkx.openInReq': 'Mở trong Yêu cầu →',
  'bkx.editSchedule': 'Sửa lịch ↗',
  'bkx.reqOnVessel': 'Yêu cầu trên tàu',
  'bkx.noReq': 'Chưa có yêu cầu trên chuyến này',
  'bkx.planChanged': 'Thay đổi kế hoạch',
  'bkx.jobLog': 'Nhật ký job',
  'bkx.portToPort': 'cảng tới cảng',
  'bkx.send': 'Gửi',
  'bkx.noOpenTodo': 'Không còn việc mở',
  'bkx.save': 'Lưu',
  'bkx.match': 'khớp',
  'bkx.diff': 'lệch',
  'bkx.copyable': 'ô trống chép được',
  'bkx.keys': 'Tab ô lệch kế · Alt+→ chép · Ctrl+Z · Ctrl+S · Esc',
  'bkx.field': 'Trường',
});

addMessages('en', {
  'bkx.newVoyage': 'New voyage',
  'bkx.resched': 'Rescheduled',
  'bkx.requests': 'requests',
  'bkx.noVessel': 'No matching vessel',
  'bkx.vesselProfile': 'Vessel profile',
  'bkx.cutoffDiff': 'Cut-off mismatch · carrier mail differs from schedule',
  'bkx.updSchedule': 'Update schedule · 2 forms',
  'bkx.sendNotice': 'Send Schedule Notice',
  'bkx.aiInput': 'AI Input from mail',
  'bkx.openInReq': 'Open in Requests →',
  'bkx.editSchedule': 'Edit schedule ↗',
  'bkx.reqOnVessel': 'Requests on vessel',
  'bkx.noReq': 'No requests on this voyage yet',
  'bkx.planChanged': 'Plan changed',
  'bkx.jobLog': 'Job log',
  'bkx.portToPort': 'port to port',
  'bkx.send': 'Send',
  'bkx.noOpenTodo': 'No open tasks',
  'bkx.save': 'Save',
  'bkx.match': 'match',
  'bkx.diff': 'diff',
  'bkx.copyable': 'empty cells copyable',
  'bkx.keys': 'Tab next diff · Alt+→ copy · Ctrl+Z · Ctrl+S · Esc',
  'bkx.field': 'Field',
});
